import * as React from "react";
import {translate, Trans} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import {Container,Row,Col} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import vodafoneLogo from "../../media/icons/vf-logo.png";

import iconError from "../../media/icons/error.svg"

class StageCallbackConfirm extends React.Component {

    // initialize Component state

    constructor(props){
        super(props);
    }


    render() {

        let callback_confirmed_title = "callback_confirmed_title";
        let your_phone_label = "your_phone_label";
        let callback_confirmed_body = "callback_confirmed_body";
        let callback_confirmed_body_2 = "callback_confirmed_body_2";
        let callback_confirmed_phone_number = "";

        // select text depending on TAM (RESULT_CODE)
        switch( parseInt( this.props.ds360APIResult.RESULT_CODE ) ) {

            case 6003:
                callback_confirmed_title = "callback_confirmed_title";
                callback_confirmed_body = "callback_confirmed_body";
                callback_confirmed_body_2 = "callback_confirmed_body_2";
                // your_phone_label = "your_phone_label";
                // callback_confirmed_phone_number = <p className={"your_phone"}>0127 123456789</p>;
                your_phone_label = "";
                callback_confirmed_phone_number = "";
                break;

            case 6004:
            case 6005:
            case 6006:
            case 6007:
            case 6008:
            case 6009:
            case 6010:
            case 6011:
            case 6013:
                callback_confirmed_title = "callback_confirmed_title_60xx";
                callback_confirmed_body = "callback_confirmed_body_60xx";
                callback_confirmed_body_2 = "";
                your_phone_label = "";
                callback_confirmed_phone_number = "";
                break;

        }

        return <Container>
            <MobileView>
                <Row className={"header"}>
                    <Col xs={2} style={{marginLeft:"-15px"}}>
                        <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                    </Col>
                </Row>
                <Row style={{paddingTop:"5vh"}}>
                    <Col xs={{ size: 12 }}>
                            <Header
                                textResource={callback_confirmed_title}
                            />
                    </Col>
                </Row>
                <Row style={{paddingTop:"20px"}}>
                    <Col xs={{ size: 12 }}>
                        <TextBody
                            textResource={your_phone_label}
                        />
                        {callback_confirmed_phone_number}
                    </Col>
                </Row>
                <Row>
                    <Col xs={{ size: 12 }}>
                            <TextBody
                                textResource={callback_confirmed_body}
                            />
                    </Col>
                </Row>
                <Row>
                    <Col xs={{ size: 12 }}>
                            <TextBody
                                textResource={callback_confirmed_body_2}
                            />
                    </Col>
                </Row>
            </MobileView>

            <BrowserView>
				<Row className={"header desktop"}>
					<Col xs={12}>
						<div className={"container"}>
							<Row>
								<Col xs={2} style={{marginLeft:"-15px"}}>
									<img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
								</Col>
							</Row>
						</div>
					</Col>
				</Row>
                <Row style={{paddingTop:"20vh"}}>
                    <Col xs={{ size: 10, offset: 1 }}>
                        <Header
                            textResource={callback_confirmed_title}
                        />
                    </Col>
                </Row>
                <Row style={{paddingTop:"20px"}}>
                    <Col xs={{ size: 10, offset: 1 }}>
                        <TextBody
                            textResource={your_phone_label}
                        />
                        {callback_confirmed_phone_number}
                    </Col>
                </Row>
                <Row>
                    <Col xs={{ size: 10, offset: 1 }}>
                        <TextBody
                            textResource={callback_confirmed_body}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={{ size: 10, offset: 1 }}>
                        <TextBody
                            textResource={callback_confirmed_body_2}
                        />
                    </Col>
                </Row>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(StageCallbackConfirm);